<div class="law-management">
  <!-- 頁面標題 -->
  <div class="page-header">
    <h2>法規資料庫管理</h2>
    <button class="btn btn-primary" (click)="refresh()" [disabled]="loading">
      <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
      重新載入
    </button>
  </div>

  <!-- 載入狀態 -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">載入中...</span>
    </div>
    <p class="mt-2">正在載入法規資料...</p>
  </div>

  <!-- 錯誤訊息 -->
  <div *ngIf="error" class="alert alert-danger" role="alert">
    <i class="fas fa-exclamation-triangle"></i>
    {{ error }}
  </div>

  <!-- 主要內容 -->
  <div *ngIf="!loading && !error" class="content">

    <!-- 統計資料色塊 -->
    <div class="stats-container">
      <div class="stats-blocks">
        <div class="stat-block stat-normal"
             [class.active]="filterStatus === 'normal'"
             (click)="onStatusFilter('normal')">
          <div class="stat-number">{{ stats.normal }}</div>
          <div class="stat-label">正常資料</div>
        </div>
        <div class="stat-block stat-failed"
             [class.active]="filterStatus === 'failed'"
             (click)="onStatusFilter('failed')">
          <div class="stat-number">{{ stats.failed }}</div>
          <div class="stat-label">擷取失敗</div>
        </div>
        <div class="stat-block stat-empty"
             [class.active]="filterStatus === 'empty'"
             (click)="onStatusFilter('empty')">
          <div class="stat-number">{{ stats.empty }}</div>
          <div class="stat-label">無內容</div>
        </div>
        <div class="stat-block stat-total"
             [class.active]="filterStatus === 'all'"
             (click)="onStatusFilter('all')">
          <div class="stat-number">{{ stats.total }}</div>
          <div class="stat-label">總計</div>
        </div>
      </div>
    </div>

    <!-- 法規來源統計色塊 -->
    <div class="source-stats-container">
      <div class="source-stats-blocks">
        <div class="source-block"
             *ngFor="let source of getSourceStatsList()"
             [class.active]="filterSource === source.name"
             (click)="onSourceFilter(source.name)">
          <div class="source-number">{{ source.count }}</div>
          <div class="source-label">{{ source.name }}</div>
        </div>
        <div class="source-block source-total"
             [class.active]="filterSource === 'all'"
             (click)="onSourceFilter('all')">
          <div class="source-number">{{ stats.total }}</div>
          <div class="source-label">全部</div>
        </div>
      </div>
    </div>

    <!-- 篩選和搜尋工具列 -->
    <div class="toolbar">
      <div class="row">
        <!-- 關鍵字搜尋 -->
        <div class="col-md-4">
          <div class="form-group">
            <label for="searchKeyword">關鍵字搜尋</label>
            <div class="input-group">
              <input type="text"
                     id="searchKeyword"
                     class="form-control"
                     placeholder="搜尋法規標題、名稱或URL"
                     [(ngModel)]="searchKeyword"
                     (input)="onSearchChange()">
              <span class="input-group-text">
                <i class="fas fa-search"></i>
              </span>
            </div>
          </div>
        </div>

        <!-- 日期區間篩選 -->
        <div class="col-md-6">
          <div class="form-group">
            <label>法規版本日期區間</label>
            <div class="row">
              <div class="col-md-5">
                <input type="date"
                       class="form-control"
                       placeholder="開始日期"
                       [(ngModel)]="startDate"
                       (change)="onDateFilterChange()">
              </div>
              <div class="col-md-2 text-center align-self-end">
                <span class="date-separator">至</span>
              </div>
              <div class="col-md-5">
                <input type="date"
                       class="form-control"
                       placeholder="結束日期"
                       [(ngModel)]="endDate"
                       (change)="onDateFilterChange()">
              </div>
            </div>
          </div>
        </div>

        <!-- 清除日期篩選 -->
        <div class="col-md-2">
          <div class="form-group">
            <label>&nbsp;</label>
            <button class="btn btn-outline-secondary w-100"
                    (click)="clearDateFilter()"
                    [disabled]="!startDate && !endDate">
              <i class="fas fa-times"></i>
              清除日期
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 資料表格 -->
    <div class="table-container">
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th class="sortable-header" (click)="onSortClick('ScanDate')">
                掃描日期
                <span class="sort-indicator" [class]="getSortIndicatorClass('ScanDate')">
                  <i class="fas fa-sort" *ngIf="!isCurrentSortField('ScanDate')"></i>
                  <i class="fas fa-sort-up" *ngIf="isCurrentSortField('ScanDate') && sortDirection === 'asc'"></i>
                  <i class="fas fa-sort-down" *ngIf="isCurrentSortField('ScanDate') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th>法規URL</th>
              <th class="sortable-header" (click)="onSortClick('law_title')">
                法規名稱
                <span class="sort-indicator" [class]="getSortIndicatorClass('law_title')">
                  <i class="fas fa-sort" *ngIf="!isCurrentSortField('law_title')"></i>
                  <i class="fas fa-sort-up" *ngIf="isCurrentSortField('law_title') && sortDirection === 'asc'"></i>
                  <i class="fas fa-sort-down" *ngIf="isCurrentSortField('law_title') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th>備註</th>
              <th class="sortable-header" (click)="onSortClick('law_version')">
                法規版本
                <span class="sort-indicator" [class]="getSortIndicatorClass('law_version')">
                  <i class="fas fa-sort" *ngIf="!isCurrentSortField('law_version')"></i>
                  <i class="fas fa-sort-up" *ngIf="isCurrentSortField('law_version') && sortDirection === 'asc'"></i>
                  <i class="fas fa-sort-down" *ngIf="isCurrentSortField('law_version') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th class="sortable-header" (click)="onSortClick('law_count')">
                條文數量
                <span class="sort-indicator" [class]="getSortIndicatorClass('law_count')">
                  <i class="fas fa-sort" *ngIf="!isCurrentSortField('law_count')"></i>
                  <i class="fas fa-sort-up" *ngIf="isCurrentSortField('law_count') && sortDirection === 'asc'"></i>
                  <i class="fas fa-sort-down" *ngIf="isCurrentSortField('law_count') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th class="sortable-header" (click)="onSortClick('fetch_status')">
                擷取狀態
                <span class="sort-indicator" [class]="getSortIndicatorClass('fetch_status')">
                  <i class="fas fa-sort" *ngIf="!isCurrentSortField('fetch_status')"></i>
                  <i class="fas fa-sort-up" *ngIf="isCurrentSortField('fetch_status') && sortDirection === 'asc'"></i>
                  <i class="fas fa-sort-down" *ngIf="isCurrentSortField('fetch_status') && sortDirection === 'desc'"></i>
                </span>
              </th>
              <th>ID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td>{{ item.ScanDate }}</td>
              <td>
                <a *ngIf="item.laws.law_url"
                   [href]="item.laws.law_url"
                   target="_blank"
                   class="law-url">
                  {{ getSourceWebsiteName(item.laws.law_url) }}
                </a>
                <span *ngIf="!item.laws.law_url" class="text-muted">
                  {{ getSourceWebsiteName(item.laws.law_url) }}
                </span>
              </td>
              <td>
                <div class="law-title">
                  <a href="javascript:void(0)"
                     (click)="openLawDetailsPopup(item)"
                     class="law-title-link"
                     title="點擊查看法條內容">
                    {{ getLawTitle(item) }}
                  </a>
                </div>
              </td>
              <td>
                <div class="memo-field">
                  <span *ngIf="!isEditingMemo(item)"
                        class="memo-text"
                        (click)="startEditMemo(item)"
                        [title]="item.check_memo || '點擊編輯備註'">
                    {{ item.check_memo || '點擊新增備註' }}
                  </span>
                  <div *ngIf="isEditingMemo(item)" class="memo-edit">
                    <input type="text"
                           class="form-control form-control-sm"
                           [(ngModel)]="editingMemoText"
                           (blur)="saveMemo(item)"
                           (keyup.enter)="saveMemo(item)"
                           (keyup.escape)="cancelEditMemo()"
                           #memoInput>
                  </div>
                </div>
              </td>
              <td>{{ item.laws.law_version }}</td>
              <td class="text-center">
                <span class="badge" [class]="getStatusClass(item)">
                  {{ getActualLawCount(item) }}
                </span>
              </td>
              <td>
                <span class="status-badge" [class]="getStatusClass(item)">
                  {{ getStatusLabel(item) }}
                </span>
              </td>
              <td>
                <span class="text-muted small">{{ item.id }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 無資料提示 -->
      <div *ngIf="filteredData.length === 0" class="no-data">
        <div class="no-data-icon">
          <i class="fas fa-inbox"></i>
        </div>
        <p class="no-data-message">沒有符合條件的法規資料</p>
        <button class="btn btn-primary" (click)="onStatusFilter('all')">
          顯示所有資料
        </button>
      </div>
    </div>

    <!-- 資料統計資訊 -->
    <div class="table-info">
      <div class="row">
        <div class="col-md-6">
          <small class="text-muted">
            顯示 {{ filteredData.length }} 筆資料，總計 {{ stats.total }} 筆
          </small>
        </div>
        <div class="col-md-6 text-end">
          <small class="text-muted">
            最後更新：{{ lastUpdated || '尚未載入' }}
          </small>
        </div>
      </div>
    </div>
  </div>
</div>

